import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthOtpService } from '../auth/auth-otp.service';
import { ProfileService } from '../services/Profile/profile.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthOtpService);
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const token = authService.getAccessToken();

  if (!token) {
    return router.parseUrl('/');
  }

  if (state.url === '/profile') {
    return true;
  }

  return profileService.getProfileData().pipe(
    map((res: any) => {
      const profile = res?.profile || res?.data?.profile || res;

      const hasNationalId =
        !!profile?.national_id_front && !!profile?.national_id_back;

      const hasPassport = !!profile?.passport_image;

      const hasKycDocument = hasNationalId || hasPassport;

      if (!hasKycDocument) {
        return router.parseUrl('/profile');
      }

      return true;
    }),
    catchError(() => {
      return of(router.parseUrl('/profile'));
    })
  );
};